import { createResourceCollection } from '@/request'
import { ResourceModel } from '@/request/types'

/**
 * A profile's current utility/plan plus its uploaded bill and latest extraction, for the admin
 * Bill Extraction tool.
 *
 * API endpoint: GET /api/admin/bill_extraction/?profile_id={id} (a single object, keyed here by
 * profile_id via computedId).
 */
export type AdminUtilityRef = {
  id: number
  name: string
  is_custom: boolean
}

export type AdminPlanRef = {
  id: number
  name: string
  is_custom: boolean
  source: string | null
}

export type AdminBillExtractionResource = {
  profile_id: number
  utility: AdminUtilityRef | null
  plan: AdminPlanRef | null
  is_plan_pending: boolean
  bill_upload: {
    file_name: string | null
    s3_url: string | null
    extraction: {
      id: number
      created: string
      rate_name: string | null
      utility_name: string | null
      rate_type: string | null
      account_number: string | null
      has_rate_schedule: boolean
      matched_utility: number | null
      matched_utility_name: string | null
      matched_plan: number | null
      matched_plan_name: string | null
      match_confidence: number | null
      match_reason: string | null
    } | null
  } | null
} & ResourceModel

export const adminBillExtractionCollection =
  createResourceCollection<AdminBillExtractionResource>({
    name: 'adminBillExtraction',
    apiConfig: {
      path: 'admin/bill_extraction',
    },
    // The endpoint returns one object per profile, not a list of id'd rows; key it by profile_id.
    computedId: (data) => data.profile_id,
    selector: (state) => state.adminBillExtraction,
  })

export const adminBillExtractionReducer =
  adminBillExtractionCollection.slice.reducer
